<template>
  <div :class="['modules-table-container', `bg-${props.color}`]">
    <h3 class="mb-0">{{ props.title }}</h3>
    <DataTable
        :value="items"
        :striped-rows="true"
        :removableSort="true"
        :rowHover="true"
        data-key="id"
        class="mt-0"
        size="small"
    >
      <Column field="code" :header="t('CODE_NAME')" sortable/>
      <Column field="title" :header="t('NAME')" sortable/>
      <Column field="type" :header="t('MODULE_TYPE')" sortable>
        <template #body="{ data }">
          {{ t(data.type) }}
        </template>
      </Column>
      <Column v-if="props.showArchived" field="archived" :header="t('ARCHIVED')" sortable>
        <template #body="{ data }">
          <Checkbox v-model="data.archived" disabled :binary="true"/>
        </template>
      </Column>
      <Column>
        <template #body="{ data }">
          <div class="text-center">
            <router-link :to="{ name: 'ManageModule', params: { id: data.id, module: data } }">
              <Button :label="t('VIEW')"/>
            </router-link>
          </div>
        </template>
      </Column>

      <template #empty>
        {{ t('NO_RESULTS') }}
      </template>
    </DataTable>
  </div>
</template>

<script setup lang="ts">
import {useI18n} from "vue-i18n";
import {computed} from "vue";

const {t, locale} = useI18n();

const props = defineProps<{
  title: string;
  showArchived: boolean;
  color: "gray" | "blue";
  items: any[];
}>();

const items = computed(() => {
  return props.items.map(item => ({...item, title: item.translations[locale.value]}));
});
</script>

<style scoped lang="scss">
.modules-table-container {
  border-left: 3px solid var(--p-color-blue-600);
  margin-bottom: 2rem;

  &.bg-gray {
    border-color: var(--p-color-white-400);

    & > h3 {
      background: var(--p-color-white-400);
    }
  }

  & > h3 {
    text-transform: uppercase;
    font-size: 18px;
    font-weight: bold;
    padding: 0.75rem;
    background: var(--p-color-blue-600);
    color: var(--p-color-white-0);
  }
}
</style>
